import styled from '@emotion/styled';
import { Icon, List, ListItem } from '@qga/roo-ui/components';

import Text from '@/components/Text';

const StyledList = styled(List)`
  list-style-type: none;
  list-style-image: none;

  ${ListItem} {
    flex-grow: 0;
  }
`;

const Amenities = ({ facilities }: { facilities: string[] }) => (
  <StyledList columns={['1', '2', '3']}>
    {facilities.map((amenity) => (
      <ListItem key={amenity} data-testid="AMENITY">
        <Icon name="done" />
        <Text ml="2" lineHeight="28px" fontWeight="400">
          {amenity}
        </Text>
      </ListItem>
    ))}
  </StyledList>
);

export default Amenities;
